import { NgModule } from '@angular/core';
import { provideState } from '@ngrx/store';
import { PermissionsFeature } from '@qtek/libs/store';
import { PermissionBadgeDirective } from './directives';

@NgModule({
  imports: [PermissionBadgeDirective],
  exports: [PermissionBadgeDirective],
  providers: [provideState(PermissionsFeature)],
})
export class PermissionsModule {}
